import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * RPM Only status per patient, as last loaded or set by the patient profile
 * header. Lets other views (the care journey roadmap) react as soon as the
 * header's RPM Only toggle changes. A patient missing from the map is unknown.
 */
interface PatientRpmOnlyState {
  byPatientId: Record<string, boolean>;
}

const initialState: PatientRpmOnlyState = {
  byPatientId: {},
};

const patientRpmOnlySlice = createSlice({
  name: "patientRpmOnly",
  initialState,
  reducers: {
    setPatientRpmOnly(
      state,
      action: PayloadAction<{ patientId: string; rpmOnly: boolean }>
    ) {
      state.byPatientId[action.payload.patientId] = action.payload.rpmOnly;
    },
  },
});

export const { setPatientRpmOnly } = patientRpmOnlySlice.actions;

export default patientRpmOnlySlice.reducer;
